
































import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import PremimumCardOne from '@/main-components/premium/premium-cards/PremimumCardOne.vue';
import PremimumCardSix from '@/main-components/premium/premium-cards/PremimumCardSix.vue';
import PremiumDiscount from './PremiumDiscount.vue';
@Component({
  components: {
    Modal,
    PremimumCardOne,
    PremimumCardSix,
    PremiumDiscount,
  },
})
export default class PremiumModal extends Vue {
  @Prop({ default: 'Title' })
  title: string;

  @Prop({ default: 'Description' })
  description: string;

  openModalPremium: any = null;
  closeModalPremium: any = null;

  mounted() {
    this.$emit('openPremiumModalAdd', this.openModalPremium);
  }

  closeModal() {
    this.closeModalPremium && this.closeModalPremium();
  }

  openModalAdd(openModal: any) {
    this.openModalPremium = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModalPremium = closeModal;
  }

  onWhatsappLinkClick() {
    this.$sendMpEvent({
      event: this.$mp_value.SubscriptionWhatsapp,
    });

    this.$sendMpEvent;
    window.open('https://wa.me/601159951420', '_blank');
  }
}
